import { prodapiAxiosClient } from "./prodApiClient";

const getFeatureSwitch = (flagKey) => {
    return prodapiAxiosClient
    .get(`/api/v1/featureSwitch/${flagKey}`) 
}

const featureSwitchApi = { getFeatureSwitch };
export default featureSwitchApi;